import React from 'react';
import styles from './LanguageSelector.module.css';
import { Locale } from '../../types';
import { useLocale } from '../../contexts/LocaleContext';
import clsx from 'clsx';

/**
 * LanguageSelector Component
 *
 * A simplified language toggle component for the login page.
 * Displays EN/RU toggle in a pill-shaped design.
 */
export const LanguageSelector: React.FC = () => {
  const { selectedLocale, setSelectedLocale } = useLocale();

  return (
    <div className={styles.language_selector}>
      <button
        onClick={() => setSelectedLocale(Locale.en)}
        className={clsx(
          styles.option,
          selectedLocale === Locale.en && styles.selected
        )}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button
        onClick={() => setSelectedLocale(Locale.ru)}
        className={clsx(
          styles.option,
          selectedLocale === Locale.ru && styles.selected
        )}
        aria-label="Переключить на русский"
      >
        RU
      </button>
    </div>
  );
};
